var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceMatched(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/face_match") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/face_match",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,8.761 C7.866,8.761 8.816,8.886 9.85,9.138 C11.024,9.431 11.974,9.823 12.7,10.312 C13.567,10.884 14,11.527 14,12.24 L14,14 L0,14 L0,12.24 C0,11.527 0.433,10.884 1.3,10.312 C2.026,9.822 2.976,9.432 4.15,9.138 C5.184,8.886 6.134,8.761 7,8.761 L7,8.761 Z M7,7.001 C6.371,7.001 5.791,6.843 5.26,6.529 C4.73,6.214 4.307,5.792 3.993,5.261 C3.678,4.73 3.521,4.15 3.521,3.521 C3.521,2.892 3.678,2.306 3.993,1.761 C4.307,1.216 4.73,0.786 5.26,0.471 C5.791,0.158 6.371,0.002 7,0.002 C7.629,0.002 8.209,0.158 8.74,0.472 C9.27,0.787 9.693,1.217 10.007,1.762 C10.322,2.307 10.479,2.893 10.479,3.522 C10.479,4.151 10.322,4.731 10.007,5.262 C9.693,5.792 9.27,6.215 8.74,6.53 C8.209,6.844 7.629,7.001 7,7.001 Z",
    id: "Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 11,
    cy: 11.092,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99,13.604 L14.498,9.097 L13.788,8.364 L9.99,12.174 L8.212,10.383 L7.502,11.092 L9.99,13.604 L9.99,13.604 Z M11,6.092 C11.913,6.092 12.759,6.32 13.536,6.777 C14.289,7.21 14.882,7.803 15.315,8.556 C15.772,9.333 16,10.179 16,11.092 C16,12.005 15.772,12.851 15.315,13.628 C14.882,14.381 14.289,14.974 13.536,15.407 C12.759,15.864 11.913,16.092 11,16.092 C10.087,16.092 9.241,15.864 8.464,15.407 C7.711,14.967 7.118,14.369 6.685,13.616 C6.228,12.839 6,11.997 6,11.092 C6,10.187 6.228,9.345 6.685,8.568 C7.125,7.815 7.723,7.218 8.476,6.778 C9.253,6.319 10.095,6.092 11,6.092 Z",
    id: "Shape",
    fill: "#68AC58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceMatched);
export default __webpack_public_path__ + "static/media/face_matched.f529e846b3703b4a500cc94b692e03e2.svg";
export { ForwardRef as ReactComponent };